<template>
  <div>
    <h2 v-if="title">{{ title }}</h2>
    <p v-if="!tracks.length" class="empty-state">{{ emptyText }}</p>
    <ul v-else class="track-list">
      <TrackCard
        v-for="track in tracks"
        :key="track.id"
        :track="track"
        :show-delete="showDelete"
        @select="$emit('select', $event)"
        @delete="$emit('delete', $event)"
      />
    </ul>
  </div>
</template>

<script setup>
import TrackCard from './TrackCard.vue'

defineProps({
  tracks: {
    type: Array,
    default: () => [],
  },
  title: {
    type: String,
    required: true,
  },
  emptyText: {
    type: String,
    default: 'Пока нет треков.',
  },
  showDelete: {
    type: Boolean,
    default: false,
  },
})

defineEmits(['select', 'delete'])
</script>
